module.exports = __webpack_public_path__ + "static/media/ExempliGratia.66ffd5bd.pdf";